export type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType extends readonly (infer ElementType)[] ? ElementType : never;

export default function removeDuplicates<ObjectType extends Record<string, unknown>, ArrayType extends ObjectType[]>(arr: ArrayType, field: keyof ObjectType): ArrayType {
  return arr.filter((obj, index, self) =>
      index === self.findIndex((el) => el[field] === obj[field])
  ) as ArrayType;
}
